/**
 * @file Ecommerce order API helpers.
 */

import appSettings from "../../settings/appSettings";

/**
 * Determines the environment of the Order API based on its base URL.
 *
 * @returns {string} The environment of the Order API: local, dev, qa, uat, or prod (default).
 */
export function getOrderApiEnv(): string {
  const { orderApiConfig } = appSettings;
  const orderApiBaseUrl = orderApiConfig.baseUrl;

  if (orderApiBaseUrl.includes("local")) return "local";
  if (orderApiBaseUrl.includes("dev")) return "dev";
  if (orderApiBaseUrl.includes("qa")) return "qa";
  if (orderApiBaseUrl.includes("uat")) return "uat";

  return "prod";
}
